<template>
  <v-container fluid fill-height class="text-xs-center pa-0 ma-0">
    <vue-confirm-dialog></vue-confirm-dialog>
    <v-layout style="background-color: #ECECEC" class="pa-0 ma-0 mb-5">
      <v-row>
        <v-flex class="lg2 md2 elevation-3" style="background-color: #95C72B">
          <v-layout class="mb-5 justify-center align-center align-self-center">
            <img src="../../public/assets/logo.png" width="80%" contain style="margin-top: 50px">
          </v-layout>

          <v-layout class="mb-5 justify-center align-center align-self-center">
            <v-card-title style="color: white; font-weight: bold; font-size: 30px">Payment<br>Portal</v-card-title>
          </v-layout>
        </v-flex>

        <v-flex>
          <v-layout row class="ma-8 justify-space-between">
            <v-flex style="display: inline-flex">
              <v-switch
                label="Edit"
                class="pa-0 ma-0 pt-3"
                v-model="editUserDetails"
                color="#95C72B"
              ></v-switch>

              <v-switch
                v-if="editUserDetails"
                label="Change Password"
                class="pa-0 ma-0 pl-5 ml-5 pt-3"
                v-model="editUserPasswordDetails"
                color="#95C72B"
              ></v-switch>
            </v-flex>
            <v-icon class="mx-3"
                    large
                    color="#95C72B"
                    @click="logout()"
            >
              logout
            </v-icon>
          </v-layout>

          <!-- Profile Information Form -->
          <v-flex column class="ml-7 mt-5 lg10">
            <!-- First Name & Last Name -->
            <v-flex row class="align-center justify-center pa-0 ma-0">
              <h1 class="fieldName align-start justify-start">First Name</h1>
              <v-text-field
                class="textfields_style mb-1"
                background-color="#edf3ea"
                :disabled="!editUserDetails"
                label="Enter first name"
                v-model="firstName"
                solo
                hide-details
                append-icon="person"
                type="text"
              />
              <h1 class="fieldName ml-5">Last Name</h1>
              <v-text-field class="textfields_style mb-1"
                            background-color="#edf3ea"
                            label="Enter last name"
                            :disabled="!editUserDetails"
                            solo
                            hide-details
                            type="text"
                            append-icon="person"
                            v-model="lastName"
              />

            </v-flex>
            <!-- Middle Name & Email -->
            <v-flex row class="align-center justify-center pa-0 ma-0 mt-3">
              <h1 class="fieldName">Middle Name</h1>
              <v-text-field class="textfields_style mb-1"
                            background-color="#edf3ea"
                            label="Enter middle name"
                            :disabled="!editUserDetails"
                            solo
                            hide-details
                            type="text"
                            append-icon="person"
                            v-model="middleName"
              />
              <h1 class="fieldName ml-5">Email Address</h1>
              <v-text-field class="textfields_style mb-1"
                            background-color="#edf3ea"
                            label="Enter email address"
                            :disabled="!editUserDetails"
                            solo
                            hide-details
                            type="email"
                            append-icon="email"
                            v-model="emailId"
                            readonly="readonly"
              />

            </v-flex>
            <!-- DOB & Contact -->
            <v-flex row class="align-center justify-center pa-0 ma-0 mt-3">
              <h1 class="fieldName">Date of Birth</h1>
              <v-text-field class="textfields_style mb-1"
                            style="width: 27.5%"
                            background-color="#edf3ea"
                            :disabled="!editUserDetails"
                            label="Enter Date of Birth"
                            solo
                            hide-details
                            type="date"
                            v-model="dob"
              />
              <h1 class="fieldName ml-5">Contact</h1>
              <v-text-field class="textfields_style mb-1"
                            background-color="#edf3ea"
                            :disabled="!editUserDetails"
                            label="Enter phone number"
                            solo
                            hide-details
                            type="text"
                            append-icon="phone"
                            v-model="contact"
              />
            </v-flex>
            <!-- Address 1 & Address 2 -->
            <v-flex row class="align-center justify-center pa-0 ma-0 mt-3">
              <h1 class="fieldName">Address 1</h1>
              <v-text-field class="textfields_style mb-1"
                            :disabled="!editUserDetails"
                            background-color="#edf3ea"
                            label="Enter address 1"
                            solo
                            hide-details
                            type="text"
                            append-icon="map"
                            v-model="address1"
              />
              <h1 class="fieldName ml-5">Address 2</h1>
              <v-text-field class="textfields_style mb-1"
                            background-color="#edf3ea"
                            label="Enter address 2"
                            solo
                            :disabled="!editUserDetails"
                            hide-details
                            type="text"
                            append-icon="map"
                            v-model="address2"
              />
            </v-flex>
            <!-- City & State -->
            <v-flex row class="align-center justify-center pa-0 ma-0 mt-3">
              <h1 class="fieldName">City</h1>
              <v-text-field class="textfields_style mb-1"
                            background-color="#edf3ea"
                            :disabled="!editUserDetails"
                            label="Enter city"
                            solo
                            hide-details
                            type="text"
                            append-icon="flag"
                            v-model="city"
              />
              <h1 class="fieldName ml-5">State</h1>
              <v-select
                :items="statesdata"
                class="textfields_style mb-1"
                background-color="#edf3ea"
                :disabled="!editUserDetails"
                label="Enter state"
                solo
                hide-details
                type="text"
                append-icon="flag"
                v-model="state"
              ></v-select>
              <!--              </v-col>-->
            </v-flex>
            <!-- Postal Code & Country Code -->
            <v-flex row class="align-center justify-center pa-0 ma-0 mt-3">
              <h1 class="fieldName">Postal Code</h1>
              <v-text-field class="textfields_style mb-1"
                            background-color="#edf3ea"
                            label="Enter postal code"
                            :disabled="!editUserDetails"
                            solo
                            hide-details
                            type="text"
                            append-icon="pin"
                            v-model="postalCode"
              />

              <h1 class="fieldName ml-5">Country Code</h1>
              <v-text-field class="textfields_style mb-1"
                            background-color="#edf3ea"
                            label="Enter country code"
                            solo
                            hide-details
                            :disabled="!editUserDetails"
                            type="text"
                            append-icon="pin"
                            v-model="countryCode"
              />
            </v-flex>
            <!-- Password & Confirm Password -->
            <v-flex v-if="editUserPasswordDetails && editUserDetails" row class="align-center justify-center pa-0 ma-0 mt-3">
              <h1 class="fieldName">Password</h1>
              <v-text-field class="textfields_style mb-1"
                            background-color="#edf3ea"
                            label="Enter new password"
                            :disabled="!editUserDetails"
                            solo
                            hide-details
                            type="text"
                            append-icon="lock"
                            v-model="newpassword"
              />

              <h1 class="fieldName ml-5">Confirm Password</h1>
              <v-text-field class="textfields_style mb-1"
                            background-color="#edf3ea"
                            label="Enter confirm password"
                            solo
                            hide-details
                            :disabled="!editUserDetails"
                            type="text"
                            append-icon="lock"
                            v-model="newpasswordconfirm"
              />
            </v-flex>
            <!-- Create Employee & Order Card -->
            <v-flex style="display: none" row class="align-center justify-start pa-0 ma-0 mt-3">
              <h1 class="fieldName">Create Employee</h1>
              <v-switch
                v-model="createEmployee"
                color="#95C72B"
                style="width: 38%"
              ></v-switch>
              <h1 class="fieldName">Order Card</h1>
              <v-switch
                color="#95C72B"
                v-model="orderCard"
              ></v-switch>
            </v-flex>
            <!-- Card Type & Pay Rate -->
            <v-flex style="display: none" row class="align-center justify-center pa-0 ma-0 mt-2">
              <h1 class="fieldName">Card Type</h1>
              <v-text-field class="textfields_style"
                            background-color="#edf3ea"
                            label="Card program"
                            solo
                            :disabled="!editUserDetails"
                            hide-details
                            type="text"
                            append-icon="note"
                            v-model="cardType"
              />

              <h1 class="fieldName ml-5">Pay Rate</h1>
              <v-text-field class="textfields_style"
                            background-color="#edf3ea"
                            label="Enter Pay Rate"
                            solo
                            :disabled="!editUserDetails"
                            hide-details
                            type="number"
                            append-icon="money"
                            v-model="payRate"
              />
            </v-flex>
            <!-- SSN & Pay Type -->
            <v-flex  style="display: none" row class="align-center justify-center pa-0 ma-0 mt-2">
              <h1 class="fieldName">SSN</h1>
              <v-text-field class="textfields_style mb-1"
                            style="width: 25%"
                            background-color="#edf3ea"
                            label="Enter SSN"
                            solo
                            :disabled="!editUserDetails"
                            hide-details
                            type="number"
                            append-icon="lock"
                            v-model="SSN"
              />
              <h1 class="fieldName ml-5">Pay Type</h1>
              <v-select
                :items="payTypes"
                class="mt-4 ma-0 pa-0"
                label="Select Pay Type"
                background-color="#edf3ea"
                dense
                :disabled="!editUserDetails"
                solo
                v-model="payType"
              ></v-select>
            </v-flex>
            <transition duration="10000" v-if="add_details_error">
              <v-slide-y-transition>
                <div class="pa-2 red details-error-statement">
                  {{this.add_details_error_string}}
                </div>
              </v-slide-y-transition>
            </transition>
            <v-flex>
              <v-btn
                v-if="editUserDetails"
                class="AddNewUser align-center justify-center mt-5"
                color="#95C72B"
                style="color: white; font-weight: bold"
                large
                @click="updateUserDatavalue()"
              >
                SAVE
              </v-btn>
            </v-flex>
          </v-flex>
        </v-flex>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "Dashboard",

  data: () => {
    return{
      statesdata : ["AK","AL","AR","AZ","CA","CO","CT","DC","DE","FL","GA","HI","IA","ID","IL","IN","KS","KY","LA","MA","MD","ME","MI","MN","MO","MS","MT","NC","ND","NE","NH","NJ","NM","NV","NY","OH","OK","OR","PA","PR","RI","SC","SD","TN","TX","UT","VA","VI","VT","WA","WI","WV","WY"],
      editDetails: false,
      payTypes: ['Hourly','Daily','Weekly', 'Monthly'],
      createEmployee: true,
      editUserDetails: false,
      editUserPasswordDetails: false,
      orderCard: true,
      firstName: "",
      lastName: "",
      middleName: "",
      emailId: localStorage.getItem("email"),
      dob: "",
      contact: 0,
      address1: "",
      address2: "",
      city: "",
      state: "",
      postalCode: "",
      countryCode: "",
      cardType: "",
      payRate: 0,
      SSN: 0,
      payType: "",
      add_details_error_string: "",
      add_details_error: false,
      newpassword:'',
      newpasswordconfirm:''
    };
  },
  mounted() {
    if(localStorage.getItem("session_id") == "" || localStorage.getItem("session_id") == null){
      this.$router.push({name: "Login"})
    }
  },
  created() {
    this.$socket.$subscribe('userdetails', userDetailsData => {
      userDetailsData = userDetailsData['data']
      if(userDetailsData["address_1"] != null)
        this.address1 = userDetailsData["address_1"]
      if(userDetailsData["address_2"] != null)
        this.address2 = userDetailsData["address_2"]
      if(userDetailsData["card_program"] != null)
        this.cardType = userDetailsData["card_program"]
      if(userDetailsData["country_code"] != null)
        this.countryCode = userDetailsData["country_code"]
      if(userDetailsData["date_of_birth"] != null)
        this.dob = userDetailsData["date_of_birth"]
      if(userDetailsData["first_name"] != null)
        this.firstName = userDetailsData["first_name"]
      if(userDetailsData["last_name"] != null)
        this.lastName = userDetailsData["last_name"]
      if(userDetailsData["middle_name"] != null)
        this.middleName = userDetailsData["middle_name"]
      if(userDetailsData["pay_rate"] != null)
        this.payRate = userDetailsData["pay_rate"]
      if(userDetailsData["phone_number"] != null)
        this.contact = userDetailsData["phone_number"]
      if(userDetailsData["postal_code"] != null)
        this.postalCode = userDetailsData["postal_code"]
      if(userDetailsData["ssn"] != null)
        this.SSN = userDetailsData["ssn"]
      if(userDetailsData["state"] != null)
        this.state = userDetailsData["state"]
      if(userDetailsData["type"] != null)
        this.payType = userDetailsData["type"]
      if(userDetailsData["city"] != null)
        this.city = userDetailsData["city"]
      if(userDetailsData["create_employee"] != null)
        this.createEmployee = userDetailsData["create_employee"]
      if(userDetailsData["order_card"] != null)
        this.orderCard = userDetailsData["order_card"]
    });
    this.$socket.$subscribe('userdataupdated', payload => {
      //console.log(payload)
    });
    this.$socket.client.emit('getUserData', {email:localStorage.getItem("email"),session:localStorage.getItem("session_id")});
  },
  methods:{
    updateUserDatavalue(){
      {
        this.add_details_error = false;
        if(this.firstName == ""){
          this.add_details_error = true;
          this.add_details_error_string = "First Name cannot be empty";
        }
        else if(this.lastName == ""){
          this.add_details_error = true;
          this.add_details_error_string = "Last Name cannot be empty";
        }
        else if(this.middleName == ""){
          this.add_details_error = true;
          this.add_details_error_string = "Middle Name cannot be empty";
        }
        else if (this.emailId.match(
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ) == null) {
          this.add_details_error = true;
          this.add_details_error_string = "Please enter a valid email address";
        }
        else if(this.dob == ""){
          this.add_details_error = true;
          this.add_details_error_string = "DoB cannot be empty";
        }
        else if(this.contact == ""){
          this.add_details_error = true;
          this.add_details_error_string = "Contact number cannot be empty";
        }else if(this.contact.length < 10){
          this.add_details_error = true;
          this.add_details_error_string = "Contact number is not valid";
        }
        else if(this.address1 == ""){
          this.add_details_error = true;
          this.add_details_error_string = "Address cannot be empty";
        }
        else if(this.address2 == ""){
          this.add_details_error = true;
          this.add_details_error_string = "Address cannot be empty";
        }
        else if(this.city == ""){
          this.add_details_error = true;
          this.add_details_error_string = "City cannot be empty";
        }
        else if(this.state == ""){
          this.add_details_error = true;
          this.add_details_error_string = "State cannot be empty";
        }
        else if(this.postalCode == ""){
          this.add_details_error = true;
          this.add_details_error_string = "Postal Code cannot be empty";
        }else if(this.postalCode.length <= 5 || this.postalCode.length >= 10){
          this.add_details_error = true;
          this.add_details_error_string = "Postal Code size must be between 5 and 10 , Not " + this.postalCode.length;
        }
        else if(this.countryCode == ""){
          this.add_details_error = true;
          this.add_details_error_string = "Country Code cannot be empty";
        }
        else if(this.newpassword.length < 7 && this.editUserPasswordDetails == true){
          this.add_details_error = true;
          this.add_details_error_string = "Password cannot be less than 7 characters";
        }
        else if(this.newpasswordconfirm != this.newpassword)
        {
          this.add_details_error = true;
          this.add_details_error_string = "Confirm password and password are not same";

        }
          // else if(this.cardType == ""){
          //   this.add_details_error = true;
          //   this.add_details_error_string = "Card Type cannot be empty";
          // }
          // else if(this.payRate == ""){
          //   this.add_details_error = true;
          //   this.add_details_error_string = "Pay Rate cannot be empty";
          // }
          // else if(this.SSN == ""){
          //   this.add_details_error = true;
          //   this.add_details_error_string = "SSN cannot be empty";
        // }
        else{
          var userDetailsURL = this.$hostname+"/api/user/updateuser"
          this.add_details_error = false;
          /*var userDetailsData = new FormData();
          userDetailsData.append("address_1", this.address1)
          userDetailsData.append("address_2", this.address2)
          userDetailsData.append("card_program", this.cardType)
          userDetailsData.append("country_code", this.countryCode)
          userDetailsData.append("session",localStorage.getItem("session_id"))
          userDetailsData.append("date_of_birth", this.dob)
          userDetailsData.append("email", localStorage.getItem("email"))
          userDetailsData.append("first_name", this.firstName)
          userDetailsData.append("last_name", this.lastName)
          userDetailsData.append("middle_name", this.middleName)
          userDetailsData.append("pay_rate", this.payRate)
          userDetailsData.append("phone_number", this.contact)
          userDetailsData.append("postal_code", this.postalCode)
          userDetailsData.append("ssn", this.SSN)
          userDetailsData.append("state", this.state)
          userDetailsData.append("type", this.payType)
          userDetailsData.append("create_employee", true)
          userDetailsData.append("order_card", true)
          userDetailsData.append("city", this.city)*/
          var userDetailsData = {}
          userDetailsData["address_1"] = this.address1
          userDetailsData["address_2"] = this.address2
          userDetailsData["card_program"] = this.cardType
          userDetailsData["country_code"] = this.countryCode
          userDetailsData["session"]=localStorage.getItem("session_id")
          userDetailsData["date_of_birth"] = this.dob
          userDetailsData["email"] = localStorage.getItem("email")
          userDetailsData["first_name"] = this.firstName
          userDetailsData["last_name"] = this.lastName
          userDetailsData["middle_name"] = this.middleName
          userDetailsData["pay_rate"] = this.payRate
          userDetailsData["phone_number"] = this.contact
          userDetailsData["postal_code"] = this.postalCode
          userDetailsData["ssn"] = this.SSN
          userDetailsData["state"] = this.state
          userDetailsData["type"] = this.payType
          userDetailsData["create_employee"] = true
          userDetailsData["order_card"] = true
          userDetailsData["city"] = this.city
          userDetailsData["newpassword"] = this.newpassword
          this.$socket.client.emit('updateUserData', userDetailsData);
          return
          /*axios
            .post(userDetailsURL, userDetailsData)
            .then((response) => {
              if(response.data.state == 'Success'){
                alert("Record Updated Successfully")
                console.log(response)
              }
            })*/
        }
      }
    },
    logout(){
      this.$confirm(
        {
          message: 'Are you sure you want to logout?',
          button: {
            no: 'No',
            yes: 'Yes'
          },

          callback: confirm => {
            if (confirm) {
              this.logoutaction()
            }
          }
        }
      )
    },
    logoutaction(){
      var logoutURL = this.$hostname+"/api/user/logout"
      var logoutData = new FormData();
      logoutData.append("email",localStorage.getItem("email"))
      logoutData.append("session",localStorage.getItem("session_id"))
      axios
        .post(logoutURL, logoutData)
        .then((response) => {
          if (response.data.state == "Success") {
            localStorage.setItem("email", "")
            localStorage.setItem("session_id", "")
            this.$router.push({name: "Login"})
          }
          else if (response.data.state == "Error"){
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
        });
    }
  }
}
</script>

<style>
.v-select__selection--disabled{
  color: #8de867 !important;
  font-weight: bold;
}
input:disabled{
  color: #8de867 !important;
  font-weight: bold;
}
.textfields_style
{
  width: 280px !important;
}
.fieldName{
  font-size: 12px;
  color: black;
  width: 13%;
  text-align: left;
}
.details-error-statement{
  border-radius: 4px;
  font-size: 14px;
  font-family: Helvetica;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/UserViews/Dashboard.vue